export default __webpack_public_path__ + "static/media/colab4.34ad3b2c.png";